import { useAuthenticationStore } from '@/stores/authentication.js';
import { useRouter } from 'vue-router'

let DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content,
  'X-Requested-With': 'XMLHttpRequest'
};

function genericApi(baseUrl, params, method) {
  const authenticationStore = useAuthenticationStore();

  // If currentUser exists in the auth store, add the token to the auth header
  if (authenticationStore.currentUser && authenticationStore.currentUser.token) {
    // jwt token
    DEFAULT_HEADERS['Authorization'] = `Bearer ${authenticationStore.currentUser.token}`
  } else if (authenticationStore.currentUser && authenticationStore.currentUser.api_key) {
    // api key
    DEFAULT_HEADERS['Authorization'] = `Bearer ${authenticationStore.currentUser.api_key}`
  } else {
    delete DEFAULT_HEADERS['Authorization'];
  }

  if (method === 'POST' || method === 'PATCH') {
    return fetch(baseUrl, {
      headers: DEFAULT_HEADERS,
      body: JSON.stringify(params),
      method,
    }).then((response) => response.json().then((json) => ({
      status: response.status,
      json,
    })))
    .catch((error) => {
      console.error('API error:', error);
      throw error;
    });
  }

  if (method === 'UPLOAD') {
    return fetch(baseUrl, {
      headers: {
        Accept: 'application/json',
        'Authorization': DEFAULT_HEADERS['Authorization'],
      },
      body: params,
      method: "PATCH"
    }).then((response) => response.json().then((json) => ({
      status: response.status,
      json,
    })));
  }

  let init = {
    headers: DEFAULT_HEADERS,
    method: method,
  };

  if (method !== 'DELETE') {
    const finalUrl = (params) ? `${baseUrl}?${params.toString()}` : `${baseUrl}`;
    return fetch(finalUrl, init).then((response) => response.json().then((json) => ({
      status: response.status,
      json,
    }))).catch((error) => {
      console.error('API error:', error);
      throw error;
    });
  } else {
    const finalUrl = (params) ? `${baseUrl}?${params.toString()}` : `${baseUrl}`;
    return fetch(finalUrl, init).then((response) => {
      if (response.status === 204) {
        // Refresh browser so users sees login page
        window.location.reload();
      }
    });
  }
}

export function createApi(url, data) {
  return genericApi(url, data, 'POST');
}

export function updateApi(url, data) {
  return genericApi(url, data, 'PATCH');
}

export function getApi(url, params) {
  return genericApi(url, params, 'GET');
}

export function getSearchApi(url, params) {
  return genericApi(url, params, 'GET');
}

export function deleteApi(url, params) {
  return genericApi(url, params, 'DELETE');
}

export function uploadApi(url, params) {
  return genericApi(url, params, 'UPLOAD');
}

export async function fetchData(url, params = null) {
  const authenticationStore = useAuthenticationStore();
  const router = useRouter();

  let data = [];
  let currentPage = 1;
  let totalCount = 0;

  do {
    // Fetch data for the current page
    const response = await getApi(url + `?page=${currentPage}` + (params ? '&' + params.toString() : ''));
    const responseData = response.json;

    // Token expired
    if (response.status === 401) {
      await authenticationStore.unauthenticateUser();
      router.push({ path: '/' });
    }

    if (responseData.data.length > 0) {
      data.push(...responseData.data);
      totalCount = responseData.meta.count;
      currentPage++;
    } else {
      break; // No more data available, exit loop
    }
  } while (data.length < totalCount); // Continue fetching until total count is reached

  return data;
}

export function formatParams(params) {
  return { data: { attributes: params } };
}